var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","disabled":_vm.checkForTags(_vm.task) || !_vm.$can('assignDeviceToVehicle')},on:{"click":function($event){return _vm.toggleAssignmentComp(_vm.task)}}},[_c('v-icon',{attrs:{"color":"blue","large":""}},[_vm._v(" mdi-link ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }